import { Fetcher } from "@/utils/fetcher";

const emiPlan = new Fetcher("emi-plan");
emiPlan.setUseToken(false);

export interface EmiPlanItem {
  id: number;
  month: number;
  charged: number;
  emi_bank_id?: number;
}

export interface EmiBank {
  id: number;
  bank_name: string;
  logo: string | null;
  slug: string;
  serial: number;
  plans: EmiPlanItem[] | string;
}

interface ActiveEmiBanksResponse {
  Success: boolean;
  Message?: string;
  Data?: EmiBank[];
}

export const getActiveEmiBanks = (slug: string = "") =>
  emiPlan.post<ActiveEmiBanksResponse>("/storefront/banks", { slug });